document.addEventListener('DOMContentLoaded', function() {
  var bar = document.getElementById('sticky-add-to-cart-bar');
  if (!bar) return;

  var productForm = bar.querySelector('form.sticky-add-to-cart-bar__form');
  var qtyInput = bar.querySelector('.sticky-qty-input');
  var decreaseBtn = bar.querySelector('.sticky-qty-btn[data-action="decrease"]');
  var increaseBtn = bar.querySelector('.sticky-qty-btn[data-action="increase"]');

  // Show bar after scrolling 300px
  function checkBarVisibility() {
    if (window.scrollY > 300) {
      bar.classList.add('visible');
    } else {
      bar.classList.remove('visible');
    }
  }
  window.addEventListener('scroll', checkBarVisibility);
  checkBarVisibility();

  // Quantity controls
  decreaseBtn.addEventListener('click', function() {
    var val = parseInt(qtyInput.value, 10) || 1;
    if (val > 1) qtyInput.value = val - 1;
  });
  increaseBtn.addEventListener('click', function() {
    var val = parseInt(qtyInput.value, 10) || 1;
    qtyInput.value = val + 1;
  });

  // AJAX add to cart
  productForm.addEventListener('submit', function(e) {
    e.preventDefault();
    var formData = new FormData(productForm);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      // Optionally show a notification or update cart UI
      window.location.href = '/cart'; // or show a drawer/notification
    })
    .catch(function() {
      alert('Error adding to cart.');
    });
  });
});